<style lang="less" src="./index.less" scoped></style>
<template>
  <div class="editor" @click.stop="errModel">
    <div class='fold-btns'  :class='"fold"+foldType'>
      <a-tooltip placement="left">
        <template slot="title">
          {{foldType !== 2 ? '展开对标池' : '折叠需求池'}}
        </template>
        <a-icon type="caret-right" @click.stop='fold(0)' class='less' v-show='foldType>0'/>
      </a-tooltip>
      <a-tooltip placement="right">
        <template slot="title">
          {{foldType !== 0 ? '展开需求池' : '折叠对标池'}}
        </template>
        <a-icon type="caret-left" @click.stop='fold(1)' class='more' v-show='foldType<2'/>
      </a-tooltip>
    </div>
    <div class="left" v-show = 'foldType !== 2 && this.foldShow'>
      <div class="left--top">
        <a-button
          class="search"
          @click.stop="onLocalSearch"
          icon="search"
          type="primary"
          size="small"
          ghost
          >全局搜索</a-button
        >
        <a-button
          class="fold"
          style="margin-right: 20px"
          ghost
          type="primary"
          size="small"
          @click.stop="leftFold"
        >
          <img src="../../img/fold.png" />
          {{ left.isFold ? "全部折叠" : "全部展开" }}</a-button
        >
      </div>
      <div class="left--content">
        <div class="head__wrapper">
          <div class="col--app firTitle">对标应用</div>
          <head-title class="col--1 level1" style="position: relative;">
            <a-button
              @click.stop="onChangeAll"
              slot="right"
              type="primary"
              size="small"
              :disabled="functions.left.length === 0"
              >全部导入</a-button
            >
            一级功能
            <div id="allBtnImport" style="width: 76px;height: 33px;right: 2px;top: 0px;position: absolute;"></div>
          </head-title>
          <head-title class="col--2">二级功能</head-title>
        </div>
        <div class="left--body">
          <div class="apps col--app">
            <div class="plus" id="Plus" @click.stop="addProject">
              <a-icon type="plus" />
              <span class="name--plus">新增对标</span>
            </div>
            <ul class="app__list" :style="{ height: appHeight }">
              <li
                :id="wrapId(app._id)"
                class="app"
                @click.stop="onSelectApp(app, index)"
                :class="wrapClass(app)"
                :key="index"
                v-for="(app, index) in apps"
              >
                <div class="up" v-if="app.is_sticky">
                  <img src="../../img/up.png" alt="" />
                </div>
                <div class="icon">
                  <img
                    :src="
                      app.icon ||
                        'https://hexyun.oss-cn-beijing.aliyuncs.com/18600410326/97afc077b3e0f584ce2d5758bbc3a83a.png'
                    "
                    alt=""
                  />
                </div>
                <a-tooltip placement="right">
                  <template slot="title">
                    {{ app.name }}
                  </template>
                  <span class="name">{{ app.name }}</span>
                </a-tooltip>
                <a-dropdown class="setting" :trigger="['click']">
                  <a-icon type="ellipsis" />
                  <a-menu slot="overlay">
                    <a-menu-item @click.stop="upApp(app)">
                      {{ app.is_sticky ? "取消置顶" : "置顶" }}
                    </a-menu-item>
                    <a-menu-item v-if="!app.is_inherit">
                      <a-popconfirm
                        placement="right"
                        :title="`确认删除${app.name}及其功能?`"
                        @confirm="delApp(app)"
                        okText="确认"
                        cancelText="取消"
                      >
                        <a href="#">删除</a>
                      </a-popconfirm>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <!-- <remove tooltip @delete="onDeleteApp(app, index)" class="remove" /> -->
              </li>
            </ul>
          </div>
          <div class="func">
            <div
              v-if="functions.left.length"
              class="func__content"
              :style="{ height: viewHeight }"
            >
              <function
                ref="leftFn"
                v-for="(fn, index) in functions.left"
                :is-fold="left.isFold"
                :index="index + 1"
                :key="fn._id"
                :func="fn"
                @changeAll="addAll"
                @changeItem="addItem"
                @selectChildrensItem='selectChildrensItem'
                :detail="viewMode === 'detail'"
                :search-value="searchValue"
                :left-select-item="leftSelectItem"
              ></function>
            </div>
            <div v-else class="func__content" :style="{ height: viewHeight }">
              <div class="func__empty">
                <a-empty>
                  <span slot="description">请选择应用</span>
                </a-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mid" v-show = 'foldType === 1'></div>
    <div class="right" v-show = 'foldType !== 0 && this.foldShow'>
      <div class="left--top">
        <a-input-search
          size="small"
          allow-clear
          class="search col--1"
          placeholder="筛选"
          v-model="searchValue"
        >
          <a-button
            @click.stop="onSearch"
            type="primary"
            size="small"
            slot="enterButton"
            >搜索</a-button
          >
        </a-input-search>
        <a-button @click.stop="onPrev" size="small">
          <a-icon type="caret-left"
        /></a-button>
        <span class="search__count"
          >{{ this.searchIdx + 1 }} / {{ searchList.length }}</span
        >
        <a-button @click.stop="onNext" size="small">
          <a-icon type="caret-right"
        /></a-button>
        <div class="btns--smart">
          <!--          <a-button :disabled="canUndo" @click="onUndo" icon="undo" ghost type="primary" size="small">撤销</a-button>-->
          <!--          <a-button :disabled="canRedo" @click="onRedo" icon="redo" ghost type="primary" size="small">重做</a-button>-->
          <a-button
            class="fold"
            @click.stop="rightFold"
            ghost
            type="primary"
            size="small"
            ><img src="../../img/fold.png" />
            {{ right.isFold ? "全部折叠" : "全部展开" }}</a-button
          >
          <a-popconfirm
            title="清空所选功能?"
            @confirm="onEmpty"
            okText="确定"
            cancelText="取消"
            placement="bottom"
          >
            <a-button class="fold" ghost type="primary" size="small"
              >清空</a-button
            >
          </a-popconfirm>
        </div>
      </div>
      <div class="head__wrapper">
        <head-title class="col--1 level level1">
          一级功能
          <a-button
            :disabled="loader.feat"
            type="link"
            class="func"
            @click.stop="addFeat"
            slot="right"
            ><a-icon type="plus" /><i class="add">新增</i></a-button
          >
        </head-title>
        <head-title class="col--2 level">
          二级功能
          <a-button
            :disabled="loader.func"
            type="link"
            class="func"
            @click.stop="addFunc"
            slot="right"
            ><a-icon type="plus" /><i class="add">新增</i></a-button
          >
        </head-title>
      </div>
      <div class="left--body">
        <div id="func_list" class="func">
          <div
            v-if="functions.right.length"
            class="func__content"
            :style="{ height: viewHeight }"
          >
            <draggable
              class="draggable__wrapper"
              handle=".check.tip"
              ghost-class="ghost"
              @end="onEnd"
              direction="vertical"
              :move="checkMove"
              group="fns"
              v-model="rightList"
            >
              <function
                @drag-end="onFuncDragEnd"
                ref="rightFn"
                v-for="(fn, index) in functions.right"
                :is-fold="right.isFold"
                :index="index + 1"
                :key="fn._id"
                :func="fn"
                :detail="viewMode === 'detail'"
                :search-text="searchText"
                @delete="onDeleteFunc"
                @selectChildrensItem='selectChildrensItem'
                edit
                :search-value="searchValue"
                :select-item="selectItem"
              >
                <!-- <div slot="mvp">111</div> -->
              </function>
            </draggable>
          </div>
          <div v-else class="func__content" :style="{ height: viewHeight }">
            <div class="func__empty">
              <a-empty>
                <span slot="description">请选择对标功能或添加功能</span>
              </a-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='childrens' v-show = 'foldType !== 1'>
      <mvp :edit="childrensIsEdit" :childrens-item='childrensItem' :fold-show='foldShow' :fold-type='foldType' @foldChange='foldChange'></mvp>
    </div>
    <version ref="version"></version>
    <div class="footer">
      <div class="report left">
        <div class="report__details">
          <!-- <div class="price">
            <div class="money">{{ calcLeft.max_price | currency('¥', 0) }}</div>
            <div class="day">{{ calcLeft.max_time }} 小时</div>
            <div class="label">max</div>
          </div>
          <div class="price">
            <div class="money">{{ calcLeft.min_price | currency('¥', 0) }}</div>
            <div class="day">{{ calcLeft.min_time }} 小时</div>
            <div class="label">min</div>
          </div> -->
        </div>
        <div class="report__tip">
          <div class="tip">
            <span class="sum">对标:</span>&nbsp;{{
              leftCount.feat
            }}个一级功能，{{ leftCount.func }} 个二级功能
          </div>
        </div>
      </div>
      <div class="mid"></div>
      <div class="report right">
        <div class="prices">
          <!-- <div class="price">
            <div class="money">{{ calcRight.max_price | currency('¥', 0) }}</div>
            <div class="day">{{ calcRight.max_time }} 小时</div>
            <div class="label">max</div>
          </div>
          <div class="price">
            <div class="money">{{ calcRight.min_price | currency('¥', 0) }}</div>
            <div class="day">{{ calcRight.min_time }} 小时</div>
            <div class="label">min</div>
          </div> -->
        </div>
        <div class="report__tip">
          <div class="tip">
            <span class="sum">已选:</span>&nbsp;{{
              rightCount.feat
            }}
            个一级功能，{{ rightCount.func }}个二级功能
          </div>
          <a-button
            id="Editor"
            :disabled="!rightCount.feat"
            @click.stop="goEditor"
            class="report--next report--editor"
            type="primary"
            >编辑器</a-button>
          <a-button
            :disabled="!rightCount.feat"
            @click.stop="goView"
            class="report--next report--view"
            type="primary"
            >全局预览</a-button>
          <!-- <a-button
            :disabled="!rightCount.feat"
            @click.stop="goNext"
            class="report--next"
            type="primary"
            >下一步</a-button> -->
        </div>
      </div>
    </div>
    <div class="keyboard" v-if="!showKeys" @click.stop="showKeys = true"></div>
    <div class="keyboard--show" v-if="showKeys">
      <a-icon class="remove" @click.stop="showKeys = false" type="close"></a-icon>
      <h3 class="title">快捷键</h3>
      <p class="desc"><span>Shift+Enter：</span><span>新建功能</span></p>
      <p class="desc"><span>Ctrl+Enter：</span><span>新建子功能</span></p>
<!--      <p class="desc">-->
<!--        <span>Shift+{{ isMac ? "Delete" : "BackSpace" }}：</span-->
<!--        ><span>删除功能</span>-->
<!--      </p>-->
      <p class="desc">
        <span>Shift+<a-icon type="arrow-up" /> ：</span
        ><span>向上选中功能</span>
      </p>
      <p class="desc">
        <span>Shift+<a-icon type="arrow-down" />：</span
        ><span>向下选中功能</span>
      </p>
      <p class="desc">
        <span>Shift+<a-icon type="arrow-left" />：</span
        ><span>向左选中功能</span>
      </p>
      <p class="desc">
        <span>Shift+<a-icon type="arrow-right" />：</span
        ><span>向右选中功能</span>
      </p>
      <p class="desc">
        <span>Shift+click：</span ><span>展开/收起 功能(mvp)</span>
      </p>
    </div>
    <div class='spin' v-show=spining>
      <a-spin size='large' />
    </div>
    <!-- 引导浮窗 Strat -->
    <div v-show="guideModelOutDone.done" id="guideModel_outline" class='guideModel_outline' :style="guideModelOutDone.style"></div>
    <div v-show="guideModel.done" class="guideModelBox">
      <div v-show="guideModel.done" id="guideModel" class="guideModel" :style="guideModel.style">
        <div>
          <span><span style="font-weight: 600;">{{guideModel.titleNum}}</span><span style="color: rgba(0, 0, 0, 0.45);margin-right:10px;">/4</span><span style='color: rgba(0,0,0,0.85)'>{{guideModel.titleName}}</span></span>
          <span>
            <svg style="margin: 7px 0 0 0px;"  @click.stop="addClose" t="1610437575575" class="icon" viewBox="0 0 1029 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1119" width="10" height="10"><path d="M84.917488 1017.691102a84.422555 84.422555 0 0 1-59.940014-24.48254 84.422555 84.422555 0 0 1 0-119.880028L389.68291 511.155774 31.731279 148.138789A84.422555 84.422555 0 1 1 151.611306 29.947213L507.030261 389.587296 869.203021 29.102987a84.422555 84.422555 0 1 1 119.880028 119.880028L627.754515 511.155774l361.328534 364.705437a84.422555 84.422555 0 1 1-119.880028 118.191576L507.030261 629.347351l-362.172759 363.861211A84.422555 84.422555 0 0 1 84.917488 1017.691102z" fill="#383B48" p-id="1120"></path></svg>
          </span>
        </div>
        <div><img :src="require('../../../assets/'+guideModel.url+'.svg')"></div>
        <div>{{guideModel.content}}</div>
        <div><button @click.stop="addGuideModelBtn(guideModel.btn,guideModel.titleNum)">{{guideModel.btn}}</button></div>
      </div>
    </div>
     <div class="guideIcon" @click.stop="addDoubt">
        <img :src="require('../../../assets/question-circle.svg')">
        <p>帮助</p>
      </div>
      <div v-show="doubt" class="doubt">
        <p @click.stop='qrCode' :style="doubtColor == 1 ? 'background:#FA883D;color:#fff;': 'background:#FFF;color:#000'">联系我们</p>
        <p @click.stop="addGuide" :style="doubtColor == 2 ? 'background:#FA883D;color:#fff;': 'background:#FFF;color:#000'">使用指南</p>
      </div>
      <div v-show='guideQRcode' class='qrCode'>
        <img :src="require('../../../assets/QRcode.png')">
        <p>宜创无代码<br>官方客服微信</p>
      </div>
    <!-- 引导浮窗 End -->
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Function from '../function2/index.vue'
import HeadTitle from '../head/title.vue'
import mvp from '../mvp/index.vue'
// import remove from '../delete.vue'
import version from '../version/index.vue'
import undoRedoHistory from '$store/plugins/undo-redo/History'
import Mousetrap from 'mousetrap'
import draggable from 'vuedraggable'
// eslint-disable-next-line no-unused-vars
import MousetrapGlobal from 'mousetrap/plugins/global-bind/mousetrap-global-bind'
import direct from './functions'
// import { stringify } from 'query-string'
import { plus } from '@axe/precision'
const EMPTY_LIST = []
export default {
  name: 'editor',
  components: {
    Function,
    HeadTitle,
    // remove,
    version,
    draggable,
    mvp
  },
  data () {
    return {
      // 引导浮窗 Start
      guideModel: {
        done: false,
        titleNum: 1,
        url: 'addPlatform',
        titleName: '添加平台',
        content: '你可以添加该项目的客户端平台',
        btn: '下一步',
        style: {
          inset: '112px auto auto 165px'
        }
      },
      guideModelOutDone: {
        done: false,
        style: {
          width: '83px',
          height: '30px',
          inset: '69px auto auto 91px'
        }
      },
      doubtColor: 0,
      guideQRcode: false,
      doubt: false,
      // 引导浮窗 End
      loader: {
        feat: false,
        func: false
      },
      drag: {
        from: null,
        to: null
      },
      isMac: /mac/i.test(window.navigator.userAgent),
      showKeys: false,
      addIndex: -1,
      right: {
        feat: null,
        featIndex: -1,
        func: null,
        funcIndex: -1,
        isFold: true
      },
      left: {
        isFold: true
      },
      currentIndex: 0,
      versionVisible: false,
      searchText: '',
      appHeight: `${window.innerHeight - 210 - 72 - 72}px`,
      viewHeight: `${window.innerHeight - 124 - 72 - 72}px`,
      searchValue: '',
      selectItem: {},
      leftSelectItem: {},
      io: {},
      searchIdx: -1,
      searchCount: 0,
      searchList: [],
      foldType: 1,
      childrensItem: {},
      foldShow: true,
      spining: false
    }
  },
  methods: {
    ...mapActions('editor', [
      'setApps',
      'removeApp',
      'rightManager',
      'syncFeat',
      'leftManager',
      'setUser',
      'setLoading'
    ]),
    checkMove (e) {
      const { draggedContext, relatedContext, originalEvent } = e
      const from = (this.drag.from = draggedContext)
      const to = (this.drag.to = relatedContext)
      const element = originalEvent.toElement
      let positionX = 0
      // 处理拖拽到2级的逻辑
      if (to.element && to.element.level === 2 && element) {
        positionX = element.getBoundingClientRect().x
        positionX = originalEvent.clientX - positionX
        console.log(positionX < -1, originalEvent.pageX, originalEvent.offsetX)
        if (from.element.level === 1) return false
        return positionX < -1
      } else {
        // 处理拖拽到1级逻辑
        const funcIndex = element.getAttribute('data-func-index')
        console.log('feat', funcIndex)
        if (funcIndex) return false
        // console.log(to.element.level, element)
        return true
      }
    },
    // 引导浮窗 Strat
    errModel () {
      this.doubt = false
      this.guideQRcode = false
      this.doubtColor = 0
    },
    // 引导模式下一步按钮
    addGuideModelBtn (value, num) {
      if (value === '下一步') {
        this.guideModel.titleNum = num + 1
        if (this.guideModel.titleNum === 2) {
          this.$event.$emit('addPlatform', false)
          this.guideModel = {
            done: true,
            titleNum: 2,
            url: 'benchmarking',
            titleName: '对标应用',
            content: '你可以对标系统的应用模板或者你的其他项目',
            btn: '下一步',
            style: {
              inset: '276px auto auto 18px'
            }
          }
          this.guideModelOutDone = {
            done: true,
            style: {
              width: '83px',
              height: '23px',
              inset: '116px auto auto 26px'
            }
          }
          let Plus = document.getElementById('Plus')
          Plus.classList.add('animations')
        }
        if (this.guideModel.titleNum === 3) {
          this.guideModel = {
            done: true,
            titleNum: 3,
            url: 'Import',
            titleName: '导入对标应用功能',
            content: '你可以把对标的功能，导入到你的项目',
            btn: '下一步',
            style: {
              inset: '190px auto auto 308px'
            }
          }
          this.guideModelOutDone = {
            done: false,
            style: {
              width: '76px',
              height: '32px',
              inset: '153px auto auto 395px'
            }
          }
          let Plus = document.getElementById('Plus')
          Plus.classList.remove('animations')
          let allBtnImport = document.getElementById('allBtnImport')
          allBtnImport.classList.add('animations')
        }
        if (this.guideModel.titleNum === 4) {
          this.guideModel = {
            done: true,
            titleNum: 4,
            url: 'editor',
            titleName: '进入编辑器',
            content: '梳理完你的项目功能后，就可以进入编辑器，开始开发啦',
            btn: '完成',
            style: {
              inset: 'auto 110px 96px auto'
            }
          }
          this.guideModelOutDone = {
            done: true,
            style: {
              width: '80px',
              height: '42px',
              inset: 'auto 114px 15px auto'
            }
          }
          let allBtnImport = document.getElementById('allBtnImport')
          allBtnImport.classList.remove('animations')
        }
      } else if (value === '完成') {
        this.wipeData()
      }
    },
    qrCode () {
      this.doubtColor = 1
      this.guideQRcode = !this.guideQRcode
    },
    // 引导按钮
    addGuide () {
      this.doubtColor = 2
      this.guideModel.done = true
      this.guideModelOutDone.done = false
      if (this.guideModel.titleNum === 1) {
        this.$event.$emit('addPlatform', true)
      }
      this.doubtColor = 0
      this.guideQRcode = false
      this.doubt = false
    },
    addClose () {
      this.wipeData()
    },
    // 数据还原
    wipeData () {
      this.doubtColor = 0
      this.$event.$emit('addPlatform', false)
      this.guideModel = {
        done: false,
        titleNum: 1,
        url: 'addPlatform',
        titleName: '添加平台',
        content: '你可以添加该项目的客户端平台',
        btn: '下一步',
        style: {
          inset: '112px auto auto 165px'
        }
      }
      this.guideModelOutDone = {
        done: false,
        style: {
          width: '83px',
          height: '30px',
          inset: '69px auto auto 91px'
        }
      }
      let Plus = document.getElementById('Plus')
      Plus.classList.remove('animations')
      let allBtnImport = document.getElementById('allBtnImport')
      allBtnImport.classList.remove('animations')
      let Editor = document.getElementById('Editor')
      Editor.classList.remove('animations')
    },
    // 疑问按钮
    addDoubt () {
      this.doubtColor = 0
      this.doubt = !this.doubt
      this.guideQRcode = false
    },
    // 引导浮窗 End

    swapFunc (list, sourceIdx, targetIdx, sourceFeatIdx, targetFeatIdx) {
      let source
      if (sourceFeatIdx === targetFeatIdx) {
        this.swap(list[sourceFeatIdx].functions, sourceIdx, targetIdx)
      } else {
        source = list[sourceFeatIdx].functions[sourceIdx]
        list[sourceFeatIdx].functions.splice(sourceIdx, 1)
        list[targetFeatIdx].functions.splice(targetIdx + 1, 0, source)
      }
    },
    swap (list, sourceIdx, targetIdx) {
      const source = list[sourceIdx]
      // 从上插到下面
      if (targetIdx > sourceIdx) {
        list.splice(targetIdx + 1, 0, source)
        list.splice(sourceIdx, 1)
        //  从下到上插入
      } else if (targetIdx < sourceIdx) {
        // 1 [2] 3 <4>  5 6
        // list.splice(sourceIdx, 1)
        list.splice(targetIdx + 1, 0, source)
        list.splice(sourceIdx + 1, 1)
      }
      // TODO: 如果选中则更新所中的索引
    },
    updateRemoteDrag ({ sourceFuncId, targetFuncId, type, insert, index }) {
      return this.$post('/wuwei/api/func/move', {
        appId: this.$route.query.app_id,
        sourceFuncId,
        targetFuncId,
        type,
        insert: insert ? 'insert' : 'other',
        index
      }).then(data => {
        console.log('sourceFuncId', sourceFuncId)
        console.log('targetFuncId', targetFuncId)
        console.log('type', type)
      })
    },
    __findIndex (parent, source) {
      const state = {}
      state.featIndex = this.functions.right.findIndex(x => x._id === parent)
      if (state.featIndex === -1) {
        state.feat = null
      } else {
        state.feat = this.functions.right[state.featIndex]
        if (source) {
          state.funcIndex = state.feat.functions.findIndex(x => x._id === source)
          state.func = state.feat.functions[state.funcIndex]
        }
      }
      return state
    },
    syncPointIndexes (meta) {
      const state = { feat: null, featIndex: -1, funcIndex: -1, func: null, selectItem: {} }
      const { feat, func, featIndex, funcIndex } = this.__findIndex(meta.parent, meta.source)
      if (!feat) return console.warn('[L1] meta.parent find in error')
      state.feat = feat
      if (meta.level === 1) {
        state.selectItem = feat
        state.featIndex = featIndex
      } else if (meta.level === 2) {
        state.funcIndex = funcIndex
        if (state.funcIndex === -1) return console.warn('[L2] meta.id find in error')
        state.func = func
        state.selectItem = state.func
      }
      this.syncAllState(state)
      return state
    },
    onFuncDragEnd (from, to, parentId, type) {
      const meta = {
        level: 2,
        source: null,
        parent: parentId
      }
      let sourceFuncId = from.element._id
      let targetFuncId
      let insert = false
      let init = false
      // let init = false
      if (!to.element) {
        // 2级拖入到 没有1级的下面的情况
        console.log('xxx', parentId)
        targetFuncId = parentId
        insert = true
      } else {
        console.log('[drag-end-start]')
        if (
          from.element.feature_id === to.element.feature_id &&
          from.index === to.index
        ) { return }
        console.log('[drag-end-starting]', to.element, from.element)
        // 同级上下移动
        if (
          from.element.feature_id === to.element.feature_id &&
          from.element.level === to.element.level
        ) {
          console.log('[drag-same-level-starting]', to.element, from.element)
        } else {
          console.log('[drag-diff-level-starting]', to.element, from.element)
          // 2拖1
          if (from.element.level > to.element.level) {
            console.log('[fetch function list starting]', from, to)
            from.element.functions = []
            init = false
            meta.level = 1
            meta.parent = sourceFuncId
          } else {
            // 同步互换feature_id
            // [from.element.feature_id, to.element.feature_id] = [to.element.feature_id, from.element.feature_id]
            // TODO: 2拖2跨级
            console.log('[drag-diff-level-starting]', to.element, from.element)
            console.log('2 --> 2')
            init = true
          }
        }
        targetFuncId = to.element._id
      }
      meta.source = sourceFuncId
      const sourceFuncIdTargetFuncIdTypeInsert = {
        type,
        targetFuncId,
        sourceFuncId,
        insert
      }
      // 处理跨级拖拽 传递索引
      console.log('init', init)
      if (init) {
        const { funcIndex } = this.__findIndex(meta.parent, meta.source)
        sourceFuncIdTargetFuncIdTypeInsert.index = funcIndex
      }
      init = false
      console.log('sourceFuncIdTargetFuncIdTypeInsert', sourceFuncIdTargetFuncIdTypeInsert)
      this.updateRemoteDrag(sourceFuncIdTargetFuncIdTypeInsert).then(x => {
        this.$event.$emit('fetchFuncList', this.$route.query.app_id, this.$route.query.benchmark_app_id, () => {
          this.syncPointIndexes(meta)
        })
      })
    },
    onEnd (e) {
      const { from, to } = this.drag
      console.log(from.element._id, to.element._id)
      if (from.index !== to.index) {
        console.log({
          sourceFuncId: from.element._id,
          targetFuncId: to.element._id,
          type: from.index > to.index ? 'up' : 'down'
        })
        this.updateRemoteDrag({
          sourceFuncId: from.element._id,
          targetFuncId: to.element._id,
          type: from.index > to.index ? 'up' : 'down'
        }).then(x => this.syncPointIndexes({ source: from.element._id, parent: from.element._id, level: 1 })
        )
      }
      return true
    },
    selectItemByIndex (featIndex, funcIndex) {
      let feat = null
      let func = null
      this.right.featIndex = featIndex
      this.right.funcIndex = funcIndex
      console.log('like search', featIndex, funcIndex)
      if (featIndex !== -1) {
        feat = this.functions.right[featIndex]
        this.right.feat = feat
      }
      if (funcIndex !== -1 && feat) {
        func = feat.functions[funcIndex]
      }
      this.right.func = func
      if (this.right.func) {
        this.$refs.rightFn[featIndex].expand()
        this.$event.$emit('appRightSelectThis', this.right.func)
        // this.selectItem = this.right.func
      } else {
        this.$event.$emit('appRightSelectThis', this.right.feat)
        // this.selectItem = this.right.feat
      }
      // this.selectItem.isEdit = true
    },
    goNext () {
      this.$router.push({
        path: '/version',
        query: {
          project_id: this.$route.query.project_id
        }
      })
      // if (this.user && this.user.temporary) {
      //   window.location.href = `${process.env.LOGIN_URL}?${stringify({
      //     project_id: this.$route.query.project_id,
      //     url: window.location.href,
      //     version_id: this.$route.query.version_id,
      //     type: 'version'
      //   })}`
      // } else {
      //   if (this.$route.query.v) {
      //     this.$router.push({
      //       path: '/version',
      //       query: {
      //         project_id: this.$route.query.project_id
      //       }
      //     })
      //   } else {
      //     window.location.href = `${process.env.NEXT_URL}?${stringify({
      //       project_id: this.$route.query.project_id,
      //       url: window.location.href,
      //       version_id: this.$route.query.version_id,
      //       type: 'version'
      //     })}`
      //   }
      // }
    },
    goView () {
      if (this.user.temporary) {
        this.$event.$emit('logIn')
        return
      }
      // 点击预览的方法,item是页面的信息,预览目前只有页面有,所以type没用
      // this.$put('/api/app/preview', {
      //   app_id: this.$route.query.app_id,
      //   project_id: this.$route.query.project_id,
      //   secureStatic: false
      // }).then(({ url }) => {
      //   if (url) {
      //     this.$open(url, '_blank', '')
      //   }
      // })
      const editorUrl = this.$paths.editor
      console.log(window.open(`${editorUrl}/${this.$route.query.app_id}/panel/?project_id=${this.$route.query.project_id}&showNlp=true&dynamicPreview=true`))
    },
    goEditor () {
      if (this.user.temporary) {
        this.$event.$emit('logIn')
        return
      }
      this.$post('/wuwei/api/commercializationLogs', {
        events: '点击',
        types: '对标页编辑器按钮'
      })

      const editorUrl = this.$paths.editor
      this.$open(`${editorUrl}/${this.$route.query.app_id}/panel/?project_id=${this.$route.query.project_id}&benchmark_app_id=${this.$route.query.benchmark_app_id}&src=${window.location.href}&benchmark_app_id=${this.$route.query.benchmark_app_id}`, '_blank', '')
    },
    onSelect () {
      if (this.searchList.length) {
        if (this.searchIdx === -1) {
          this.searchIdx = 0
        }
      }
      const element = this.searchList[this.searchIdx]
      if (!element) return
      let funcIndex = element.getAttribute('data-func-index') || -1
      let featIndex = element.getAttribute('data-feat-index') || -1
      this.selectItemByIndex(parseInt(featIndex), parseInt(funcIndex))
      // this.$nextTick(() => console.log('element', featIndex, funcIndex, this.selectItem.name, this.searchIdx))
    },
    onPrev () {
      this.searchIdx = Math.max(-1, this.searchIdx - 1)
      this.onSelect()
    },
    onNext () {
      this.searchIdx = Math.min(this.searchList.length - 1, this.searchIdx + 1)
      this.onSelect()
    },
    bindKeys () {
      // 添加1级
      Mousetrap.bindGlobal(['shift+enter'], () => {
        direct.forceLoseFocus()
        if (this.right.func) {
          this.addFunc()
        } else if (this.right.feat) {
          this.addFeat()
        }
      })
      // 添加2级
      Mousetrap.bindGlobal(['ctrl+enter'], () => {
        direct.forceLoseFocus()
        if (this.right.feat && !this.right.func) {
          this.addFunc()
        } else {
          this.$message.info('请选中1级功能')
        }
      })
      // 删除
      /*
      Mousetrap.bindGlobal(['shift+backspace', 'shift+delete'], e => {
        if (e.shiftKey && e.keyCode === 8) {
          e.preventDefault()
        }
        // if (!window.confirm('是否删除功能')) return
        if (this.right.func) {
          this.onDeleteFunc(
            this.right.func,
            this.right.funcIndex,
            this.right.feat,
            this.right.featIndex
          )
        } else {
          this.onDeleteFunc(this.right.feat, this.right.featIndex)
        }
      })
      */
      const directions = ['up', 'down', 'left', 'right']
      directions.forEach(action =>
        Mousetrap.bindGlobal([`shift+${action}`], e => {
          if (e.shiftKey && e.key.toLowerCase() === `arrow${action}`) {
            e.preventDefault()
          }
          this.onDirectDo(action)
        })
      )
    },
    onDirectDo (action) {
      direct.forceLoseFocus()
      if (typeof direct[action] !== 'function') return
      const list = this.functions.right
      switch (action) {
        case 'up':
          if (!this.right.funcIndex && !this.right.featIndex) return
          break
        case 'down':
          if (this.right.featIndex === list.length - 1) {
            if (this.right.funcIndex === -1) return
            let feat = list[this.right.featIndex]
            if (feat.functions.length - 1 === this.right.funcIndex) return
          }
          break
        case 'left':
          if (this.right.funcIndex === -1) return
          break
        case 'right':
          if (this.right.featIndex === -1) return
          break
        default:
        //
      }
      this.syncAllState(
        direct[action](
          this.functions.right,
          this.right.featIndex,
          this.right.funcIndex
        )
      )
    },
    syncAllState (state) {
      const { feat, func, featIndex, funcIndex, selectItem } = state
      this.right.feat = feat
      this.right.func = func
      this.right.featIndex = featIndex
      this.right.funcIndex = funcIndex
      if (selectItem) {
        selectItem.isEdit = true
        this.selectItem = selectItem
      } else {
        this.selectItem = {}
      }
    },
    onUndo () {
      return undoRedoHistory.undo()
    },
    onRedo () {
      return undoRedoHistory.redo()
    },
    onEmpty () {
      this.$post('/wuwei/api/func/clear', {
        app_id: this.$route.query.app_id,
        type: '0'
      }).then(() => {
        this.rightManager({
          action: 'empty'
        })
        this.syncAllState({
          feat: null,
          func: null,
          featIndex: -1,
          funcIndex: -1,
          selectItem: null
        })
        this.childrensItem = {}
      })
    },
    onDeleteFunc (item, itemIndex, parent, parentIndex) {
      let obj = {
        project_id: this.$route.query.project_id,
        app_id: this.$route.query.app_id
      }
      let query = {
        action: 'del',
        payload: {},
        parent: null
      }
      // 删除二级
      if (parent) {
        obj.feature_id = parent._id
        obj.function_id = item._id
        query.parent = parent
        query.payload = item
        query.idx = itemIndex
        query.parentIndex = parentIndex
        obj.function_id = item._id
        // 删除2级功能
        this.sendLogger({
          action: 'delete',
          type: 'func',
          func_id: item._id,
          func_type: 2
        })
      } else {
        obj.feature_id = item._id
        query.payload = item
        query.idx = itemIndex
        query.parent = null
        obj.function_id = item._id
        // 删除1级功能
        this.sendLogger({
          action: 'delete',
          type: 'func',
          func_id: item._id,
          func_type: 1
        })
      }
      this.$post('/wuwei/api/func/delete', obj).then(data => {
        const state = direct.up(
          this.functions.right,
          this.right.featIndex,
          this.right.funcIndex
        )
        // console.log('state', state)
        console.log(
          'state',
          state.featIndex,
          state.feat,
          state.funcIndex,
          state.func
        )
        this.syncAllState(state)
        if (state.funcIndex === -1 && state.feat) {
          this.selectItem = state.feat
          this.featIndex = state.featIndex
        }
        this.rightManager(query)
        this.leftManager({
          action: 'cancel',
          featureId: parent ? parent.feature_id : item.feature_id,
          payload: item,
          type: parent ? 'function' : 'feature'
        })
        if (this.functions.right.length === 0) {
          this.syncAllState({
            func: null,
            feat: null,
            featIndex: -1,
            funcIndex: -1,
            selecItem: null
          })
        }
      })
      this.childrensItem = {}
    },
    onChangeAll () {
      this.spining = true
      this.$post('/wuwei/api/func/allImport', {
        benchAppid: this.$route.query.benchmark_app_id,
        appId: this.$route.query.app_id
      }).then(data => {
        const {
          app_id: appId,
          benchmark_app_id: benchmarkAppId
        } = this.$route.query
        if (appId && benchmarkAppId) {
          this.$event.$emit('fetchFuncList', appId, benchmarkAppId)
        }
        this.spining = false
      }).catch(() => {
        this.spining = false
      })
    },
    onLocalSearch () {
      this.$event.$emit('localSearch')
    },
    wrapClass (app) {
      if (this.currentApp && app && app._id) {
        return {
          active: app._id === this.currentApp._id
        }
      }
      return {}
    },
    leftFold () {
      this.left.isFold = !this.left.isFold
      this.$refs.leftFn.forEach(x =>
        this.left.isFold ? x.foldOpen() : x.foldClose()
      )
    },
    rightFold () {
      this.right.isFold = !this.right.isFold
      this.$refs.rightFn.forEach(x =>
        this.right.isFold ? x.foldOpen() : x.foldClose()
      )
    },
    onSelectApp (app, index) {
      if (this.currentApp._id === app._id) {
        return
      }
      this.currentIndex = index
      this.$event.$emit(
        'fetchFuncList',
        this.$route.query.app_id,
        this.apps[this.currentIndex]._id
      )
    },
    showVersion () {
      this.$refs.version.show()
    },
    addProject () {
      this.$event.$emit('addProject')
    },
    __createData (data, level = 1, includeParent = false) {
      // 处理1级追加构造数据
      if (level === 1) {
        data.feature_info.functions = data.function_list
        return data.feature_info
      } else {
        console.log('data', data)
        // 添加时候添加父级情况
        data.feature_info.functions = EMPTY_LIST.concat(data.function_info || data.function_list)
        return includeParent ? data.feature_info : data.feature_info.functions[0]
      }
    },
    // 添加左边1级功能 及其2级功能
    addAll (checked, fn, edit, functionId) {
      let id = fn ? fn._id : functionId
      // 1级功能勾选
      this.$post('/wuwei/api/func/batchImport', {
        project_id: this.$route.query.project_id,
        app_id: this.$route.query.app_id,
        function_id: id,
        func_id: this.right.feat ? this.right.feat._id : null
      }).then(data => {
        // 增加1级
        this.sendLogger({
          action: 'post',
          type: 'func',
          func_type: 1,
          func_id: data.feature_info._id
        })
        // 增加2级功能
        this.sendLogger({
          action: 'post',
          type: 'func',
          func_type: 2,
          func_id: data.function_list[0]._id
        })
        let idx = -1
        if (
          this.right.feat &&
          this.right.feat._id &&
          this.right.featIndex !== -1
        ) {
          idx = this.right.featIndex
        }
        if (idx > -1) {
          idx = idx + 1
        }
        this.rightManager({
          action: 'add',
          idx: idx,
          payload: Object.assign(
            {
              isEdit: true,
              functions: []
            },
            this.__createData(data, 1, false)
          ),
          parent: null
        })
        // TODO select item
        const tIdx = idx === -1 ? this.functions.right.length - 1 : idx
        this.selectItem = this.functions.right[tIdx] || {}
        if (this.selectItem) {
          this.selectItem.isEdit = true
        }
        this.right.featIndex = tIdx
        this.right.feat = this.selectItem
        this.right.funcIndex = -1
        this.right.func = null
        this.searchValue = ''
      })
    },
    // 添加左边二级功能
    addItem (checked, fn, fns, edit, functionId, toFuncId) {
      let id = fn ? fn._id : functionId
      let funcId = this.right.func ? this.right.func._id : this.right.feat ? this.right.feat._id : null
      if (!funcId) funcId = toFuncId
      // 添加左边二级功能
      this.$post('/wuwei/api/func/batchImport',
        {
          project_id: this.$route.query.project_id,
          app_id: this.$route.query.app_id,
          function_id: id,
          func_id: funcId
        }
      ).then(data => {
        /**
         * 1. 添加2级 没有选中任何， 直接追加
         * 2. 选中1级则在1级下追加
         * 3. 选中2级则追加到2级别下面
         */
        // 添加二级功能
        this.sendLogger({
          action: 'post',
          type: 'func',
          func_id: data.function_list && data.function_list.length > 0 ? data.function_list[0]._id : data.function_info._id,
          func_type: 2
        })
        const index = this.selectItem && this.selectItem._id ? this.right.featIndex : -1
        if (index === -1) {
          this.rightManager({
            action: 'add',
            payload: Object.assign(
              {
                isEdit: true,
                functions: []
              },
              this.__createData(data, 2, index === -1)
            ),
            parent: null,
            idx: -1,
            index: index
          })
        } else {
          const idx = this.right.funcIndex === -1 ? -1 : this.right.funcIndex + 1
          this.rightManager({
            action: 'add',
            idx,
            payload: Object.assign(
              {
                isEdit: true,
                functions: []
              },
              this.__createData(data, 2, false)
            ),
            parent: this.right.feat
          })
        }

        let idx = -1
        let featIdx = this.right.featIndex === -1 ? this.functions.right.length - 1 : this.right.featIndex
        if (this.right.func && this.right.feat) {
          idx = this.right.funcIndex
        }
        // TODO select item
        const funcIdx =
          idx === -1
            ? this.functions.right[featIdx].functions.length - 1
            : idx + 1
        this.right.featIndex = featIdx
        this.right.feat = this.functions.right[featIdx]
        this.selectItem = this.functions.right[featIdx].functions[funcIdx] || {}
        this.right.func = this.selectItem
        this.right.funcIndex = funcIdx
        this.$nextTick(() => {
          this.$refs.rightFn[featIdx].expand()
        })
        this.searchValue = ''
      })
    },
    // 手动添加
    addFeat () {
      let obj = Object.create(null)
      obj.project_id = this.$route.query.project_id
      obj.app_id = this.$route.query.app_id
      obj.level = 1
      let idx = -1
      if (
        this.right.feat &&
        this.right.feat._id &&
        this.right.featIndex !== -1
      ) {
        obj.function_id = this.right.feat._id
        idx = this.right.featIndex
      }
      if (idx > -1) {
        idx = idx + 1
      }
      console.log('[Added Idx]', idx)
      this.loader.feat = true
      this.$post('/wuwei/api/func/create', {
        ...obj,
        name: ''
      })
        .then(data => {
          // 新增一级功能
          this.sendLogger({
            action: 'post',
            type: 'func',
            func_id: data.data.feature_info._id,
            func_type: 1
          })
          this.loader.feat = false
          this.rightManager({
            action: 'add',
            idx: idx,
            payload: Object.assign(
              {
                isEdit: true,
                functions: []
              },
              data.data.feature_info
            ),
            parent: null
          })
          // TODO select item
          const tIdx = idx === -1 ? this.functions.right.length - 1 : idx
          this.selectItem = this.functions.right[tIdx]
          if (this.selectItem) {
            this.selectItem.isEdit = true
          }
          this.right.featIndex = tIdx
          this.right.feat = this.selectItem
          this.right.funcIndex = -1
          this.right.func = null
          obj = Object.create(null)
          this.searchValue = ''
        })
        .catch(e => {
          this.loader.feat = false
        })
    },
    addFunc () {
      let idx = -1
      const obj = {
        project_id: this.$route.query.project_id,
        app_id: this.$route.query.app_id,
        name: '',
        level: 2
      }
      console.log('parent', this.right.feat)
      if (this.right.func && this.right.feat) {
        obj.parent = this.right.feat._id
        idx = this.right.funcIndex
        obj.function_id = this.right.func._id
      }
      if (this.right.feat) {
        obj.parent = this.right.feat._id
      }
      if (!obj.parent) {
        return this.$message.error('请选中选中1级或2级功能')
      }
      this.loader.func = true
      this.$post('/wuwei/api/func/create', obj)
        .then(data => {
          // 新增2级功能
          this.sendLogger({
            action: 'post',
            type: 'func',
            func_id: data.data.function_info._id,
            func_type: 2
          })
          this.loader.func = false
          this.rightManager({
            action: 'add',
            idx: idx === -1 ? -1 : idx + 1,
            payload: {
              ...obj,
              ...data.data.function_info,
              isEdit: true
            },
            parent: this.right.feat
          })
          // TODO select item
          const funcIdx =
            idx === -1
              ? this.functions.right[this.right.featIndex].functions.length - 1
              : idx + 1
          this.selectItem = this.functions.right[this.right.featIndex].functions[funcIdx]
          console.log(
            'after added',
            this.functions.right[this.right.featIndex],
            funcIdx,
            this.selectItem
          )
          this.right.func = this.selectItem
          this.right.funcIndex = funcIdx
          this.$refs.rightFn[this.right.featIndex].expand()
          this.searchValue = ''
        })
        .catch(e => {
          this.loader.func = false
        })
    },
    wrapId (id) {
      return `x${id}`
    },
    upApp (item) {
      if (item.is_sticky) {
        this.$post('/flow/api/5dfc9c402651202cadd72a53', {
          ...this.$route.query,
          benchmark_app_id: item._id
        }).then(result => {
          this.$event.$emit('fetch', () => {
            this.toAppView(item)
          })
        })
      } else {
        this.$post('/flow/api/5dfc9be9c343382cb3454b8c', {
          ...this.$route.query,
          benchmark_app_id: item._id
        }).then(result => {
          this.$event.$emit('fetch', () => {
            this.toAppView(item)
          })
        })
      }
    },
    delApp (item) {
      // 删除app
      this.sendLogger({
        action: 'delete',
        type: 'app',
        app_id: item.app_id
      })
      this.$post('/wuwei/api/app/deleteBench', {
        ...this.$route.query,
        benchmark_id: item._id
      }).then(result => {
        this.$event.$emit('fetch', () => {
          if (this.apps.length === 0) {
            this.leftManager({
              action: 'init',
              payload: []
            })
            const data = JSON.parse(JSON.stringify(this.$route.query))
            delete data.benchmark_app_id
            this.$router.replace({
              path: '/inner/home',
              query: data
            })
          } else {
            this.currentIndex =
              this.currentIndex > 0 ? this.currentIndex - 1 : 0
            this.$event.$emit(
              'fetchFuncList',
              this.$route.query.app_id,
              this.apps[this.currentIndex]._id
            )
          }
        })
      })
    },
    toApp (item, callback) {
      // 切换app到视图并刷新需求池
      this.$nextTick(() => {
        const tar = document.getElementById('x' + item._id)
        if (tar && tar.scrollIntoView) {
          tar.scrollIntoView({ block: 'center', behavior: 'smooth' })
        }
        this.currentIndex = this.apps.findIndex(
          items => item._id === items._id
        )
        this.$event.$emit(
          'fetchFuncList',
          this.$route.query.app_id,
          this.apps[this.currentIndex]._id,
          () => {
            if (callback) {
              callback()
            }
          }
        )
      })
    },
    toAppView (item, callback) {
      // 只滚动到视图,置顶使用
      this.$nextTick(() => {
        const tar = document.getElementById('x' + item._id)
        if (tar && tar.scrollIntoView) {
          tar.scrollIntoView({ block: 'center', behavior: 'smooth' })
        }
        this.currentIndex = this.apps.findIndex(
          items => item._id === items._id
        )
      })
    },
    onSearch () {
      this.$nextTick(() => {
        const hightlights = document.querySelectorAll('.search-highlight')
        this.searchList = hightlights
        this.searchIdx = -1
        this.onSelect()
        // 搜索功能
        this.sendLogger({
          action: 'get',
          type: 'func'
        })
      })
    },
    fold (type) {
      if (type && this.foldType < 2) {
        this.foldType++
      } else if (!type && this.foldType > 0) {
        this.foldType--
      }
      if (this.foldType === 2) {
        // 如果是展开需求池,判断是否有当前选中,没有的话判断需求池是否有数据
        if (this.selectItem._id) {
          this.childrensItem = this.selectItem
        } else if (this.functions.right[0]) {
          this.selectItem = this.functions.right[0]
          this.childrensItem = this.selectItem
        } else {
          this.selectItem = {}
          this.childrensItem = {}
        }
      } else if (this.foldType === 0) {
        if (this.leftSelectItem._id) {
          this.childrensItem = this.leftSelectItem
        } else if (this.functions.left[0]) {
          this.leftSelectItem = this.functions.left[0]
          this.childrensItem = this.leftSelectItem
        } else {
          this.leftSelectItem = {}
          this.childrensItem = {}
        }
      }
      this.foldShow = true
      this.$event.$emit('scrollTo0')
    },
    foldChange (type) {
      if (type) {
        this.foldShow = true
      } else {
        this.foldShow = false
      }
    },
    selectChildrensItem (item, type) {
      if (type) {
        this.foldType = 2
      } else {
        this.foldType = 0
      }
      this.childrensItem = item
    }
  },
  computed: {
    ...mapState('editor', ['apps', 'functions', 'viewMode', 'user', 'loading']),
    rightList: {
      get () {
        return this.functions.right
      },
      set (value) {
        this.rightManager({
          action: 'update',
          payload: value
        })
      }
    },
    loadingFunc () {
      return this.loading.funcList
    },
    leftCount () {
      return {
        feat: this.functions.left.length,
        func: this.functions.left.reduce((p, l) => {
          p += l.functions.length
          return p
        }, 0)
      }
    },
    calcLeft () {
      return this.functions.left.reduce((ll, pp) => {
        let PP = pp.functions.reduce((l, p) => {
          if (p) {
            l.time = plus(l.time, p.time)
            l.price = plus(l.price, p.price)
            l.min_time = plus(l.min_time, p.min_time || p.time)
            l.max_time = plus(l.max_time, p.max_time || p.time)
            l.min_price = plus(l.min_price, p.min_price || p.price)
            l.max_price = plus(l.max_price, p.max_price || p.price)
          }
          return l
        }, {
          price: 0,
          time: 0,
          max_price: 0,
          min_price: 0,
          max_time: 0,
          min_time: 0
        })
        if (PP) {
          ll.time = plus(ll.time, PP.time)
          ll.price = plus(ll.price, PP.price)
          ll.min_time = plus(ll.min_time, PP.min_time || PP.time)
          ll.max_time = plus(ll.max_time, PP.max_time || PP.time)
          ll.min_price = plus(ll.min_price, PP.min_price || PP.price)
          ll.max_price = plus(ll.max_price, PP.max_price || PP.price)
        }
        return ll
      }, {
        price: 0,
        time: 0,
        max_price: 0,
        min_price: 0,
        max_time: 0,
        min_time: 0
      })
    },
    calcRight () {
      return this.functions.right && this.functions.right.reduce((ll, pp) => {
        let PP = pp.functions && pp.functions.reduce((l, p) => {
          if (p) {
            l.time = plus(l.time, p.time)
            l.price = plus(l.price, p.price)
            l.min_time = plus(l.min_time, p.min_time || p.time)
            l.max_time = plus(l.max_time, p.max_time || p.time)
            l.min_price = plus(l.min_price, p.min_price || p.price)
            l.max_price = plus(l.max_price, p.max_price || p.price)
          }
          return l
        }, {
          price: 0,
          time: 0,
          max_price: 0,
          min_price: 0,
          max_time: 0,
          min_time: 0
        })
        if (PP) {
          ll.time = plus(ll.time, PP.time)
          ll.price = plus(ll.price, PP.price)
          ll.min_time = plus(ll.min_time, PP.min_time || PP.time)
          ll.max_time = plus(ll.max_time, PP.max_time || PP.time)
          ll.min_price = plus(ll.min_price, PP.min_price || PP.price)
          ll.max_price = plus(ll.max_price, PP.max_price || PP.price)
        }

        return ll
      }, {
        price: 0,
        time: 0,
        max_price: 0,
        min_price: 0,
        max_time: 0,
        min_time: 0
      })
    },
    rightCount () {
      return {
        feat: this.functions.right.length,
        func: this.functions.right && this.functions.right.reduce((p, l) => {
          p += l.functions ? l.functions.length : 0
          return p
        }, 0)
      }
    },
    currentApp () {
      return this.apps[this.currentIndex]
    },
    childrensIsEdit () {
      return this.foldType === 2
    }
  },
  mounted () {
    let obj = JSON.parse(localStorage.getItem('wuweiLogInfo'))
    if (obj.user.type === '用户') {
      if (!localStorage.getItem('guideModelState')) {
        this.guideModel.done = true
        this.guideModelOutDone.done = true
        localStorage.setItem('guideModelState', true)
      } else {
        this.guideModel.done = false
        this.guideModelOutDone.done = false
      }
    }
    this.bindKeys()
    // eslint-disable-next-line no-return-assign
    // FIX: ERROR App ID
    this.$event.$on('appChangeName', (type, item, name) => {
      // 修改1级2级功能
      this.sendLogger({
        action: 'put',
        type: 'func',
        func_id: item._id,
        func_type: type
      })
      // 修改功能信息
      this.$post('/wuwei/api/func/update', {
        _id: item._id,
        app_id: this.$route.query.app_id,
        name
      }).then(result => {
        // 二级功能修改名称成功
      })
    })

    this.$event.$on('indexSelectThis', item => {
      this.currentIndex = this.apps.findIndex(items => item._id === items._id)
      this.$event.$emit(
        'fetchFuncList',
        this.$route.query.app_id,
        this.apps[this.currentIndex]._id
      )
    })
    this.$event.$on('appSelectThis', (item, idx, parent, index) => {
      this.selectItem = item
      // 2级
      if (parent) {
        this.right.feat = parent
        this.right.featIndex = index
        this.right.func = item
        this.right.funcIndex = idx
        // 1级
      } else {
        this.right.feat = item
        this.right.featIndex = idx
        this.right.func = null
        this.right.funcIndex = -1
      }
    })
    this.$event.$on('appRightSelectThis', item => {
      // 指定需求池选中项目并滚动
      this.selectItem = item
      this.$nextTick(() => {
        const dom = document.querySelector('#x' + item._id)
        if (dom && dom.scrollIntoView) {
          dom.scrollIntoView({ block: 'center', behavior: 'smooth' })
        }
      })
    })
    this.$event.$on('appLeftSelectThis', item => {
      // 指定对标池选中项目并滚动
      this.leftSelectItem = item
      this.$nextTick(() => {
        const dom = document.querySelector('#x' + item._id)
        if (dom && dom.scrollIntoView) {
          dom.scrollIntoView({ block: 'center', behavior: 'smooth' })
        }
      })
    })
    this.$event.$on('appLeftSelectThisItem', item => {
      // 指定对标池选中项目
      this.leftSelectItem = item
    })
    this.$event.$on('scrollAppInView', (item, callback) => {
      // 指定app选中并滚动
      this.toApp(item, () => {
        this.$nextTick(() => {
          if (callback) {
            callback()
          }
        })
      })
    })
    this.$event.$on('resizeCurrentIndex', () => {
      this.currentIndex = 0
      this.right.feat = {
        functions: []
      }
      this.right.featIndex = -1
      this.right.func = {

      }
      this.right.funcIndex = -1
      // this.selectItem = {}
    })
    this.$event.$on('changeFoldType', (num) => {
      // 更改展开状态到指定状态,0左侧展开,1正常,2右侧展开
      this.foldType = num
      this.foldShow = true
    })
    this.$event.$on('openEdit', (type) => {
      this.goEditor()
    })
    this.$event.$on('goView', () => {
      this.goView()
    })
    this.$event.$on('SDD_STANDARD_FUN', (list) => {
      list.forEach(element => {
        let funName = element.value
        let toFuncName = element.value2
        if (element.behavior === '拉取') {
          let funId, tofunId, type
          let fun = this.functions.left.find((c) => c.name.indexOf(funName) !== -1)
          if (fun) {
            funId = fun._id
            type = 'first'
          } else {
          // 如果没有找到一级功能，则查找二级功能
            let fun2
            for (let i = 0; i < this.functions.left.length; i++) {
              const element = this.functions.left[i]
              fun2 = element.functions.find((c) => c.name.indexOf(funName) !== -1)
              if (fun2) {
                funId = fun2._id
                break
              }
            }
            if (fun2) {
              type = 'second'
              if (toFuncName) {
                // 是否拉取到别的功能下
                let funr = this.functions.right.find((c) => c.name.indexOf(toFuncName) !== -1)
                if (funr) tofunId = funr._id
              }
            }
          }
          if (funId) {
            if (type === 'first') {
              this.addAll(null, null, null, funId)
            } else {
              this.addItem(null, null, null, null, funId, tofunId)
            }
          }
        } else if (element.behavior === '删除') {
          let fun = this.functions.right.find(c => c.name.indexOf(funName) !== -1)
          if (fun) {
            this.onDeleteFunc(fun, 0, null, 0)
          } else { // 查询是否删除的二级功能
            this.functions.right.forEach(element2 => {
              let fun2 = element2.functions.find(c => c.name.indexOf(funName) !== -1)
              if (fun2) {
                let parent = this.functions.right.find(c => c._id === fun2.parent)
                this.$event.$emit('nlpDeleteFunc', fun2, parent)
                this.onDeleteFunc(fun2, 0, parent, 0)
              }
            })
          }
        }
      })
    })
  },
  watch: {
    'functions.left': {
      deep: true,
      handler (l, c) { }
    },
    apps: {
      deep: true,
      handler () {
        this.$nextTick(() => { })
      }
    },
    searchValue (c, l) {
      this.onSearch()
    },
    selectItem (n) {
      if (this.user && this.user.uid) {
        this.$storage.set(this.user.uid + 'selectItem', n)
      }
      // childrensItem
      if (this.foldType === 2) {
        this.childrensItem = n
      }
    },
    leftSelectItem (n) {
      if (this.user && this.user.uid) {
        this.$storage.set(this.user.uid + 'leftSelectItem', n)
      }
      if (this.foldType === 0) {
        this.childrensItem = n
      }
    },
    childrensItem (n, o) {
      if (n.functions && n.functions.length) {
        this.childrensItem = n.functions[0]
      }
    }
  },
  beforeDestroy () {
    this.io = {}
    this.searchList = []
    this.searchCount = 0
    this.searchIdx = -1
  }
}
</script>
